import initialState from './initial-state'
import * as ACTIONS from 'constant/actions/version-management'

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.VERSION_MANAGEMENT_GET_VERSION_LIST + '_PENDING':
      state = {
        ...state,
        refreshVersions: false,
        loadingVersions: true
      }
      break
    case ACTIONS.VERSION_MANAGEMENT_GET_VERSION_LIST + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          loadingVersions: false,
          versions: action.payload.data.programVersions
        }
      } else {
        state = {
          ...state,
          loadingVersions: false
        }
      }
      break
    case ACTIONS.VERSION_MANAGEMENT_SHOW_MODAL:
      state = {
        ...state,
        modalContent: action.modalContent,
        modalShowing: true
      }
      break
    case ACTIONS.VERSION_MANAGEMENT_HIDE_MODAL:
      state = {
        ...state,
        modalContent: undefined,
        modalShowing: false
      }
      break
    case ACTIONS.VERSION_MANAGEMENT_GET_CHANGE_SETS + '_PENDING':
      state = {
        ...state,
        loadingChangesets: true
      }
      break
    case ACTIONS.VERSION_MANAGEMENT_GET_CHANGE_SETS + '_FULFILLED':
      state = {
        ...state,
        changesets: action.payload.data.tfsChanges,
        loadingChangesets: false
      }
      break
    case ACTIONS.VERSION_MANAGEMENT_GET_CHANGE_SETS + '_REJECTED':
      state = {
        ...state,
        loadingChangesets: false
      }
      break
    case ACTIONS.VERSION_MANAGEMENT_REMOVE_VERSION + '_FULFILLED':
      state = {
        ...state,
        refreshVersions: true
      }
      break
    case ACTIONS.VERSION_MANAGEMENT_CREATE_NEW_VERSION + '_PENDING':
      state = {
        ...state,
        isCreatingVersion: true
      }
      break
    case ACTIONS.VERSION_MANAGEMENT_CREATE_NEW_VERSION + '_REJECTED':
      state = {
        ...state,
        isCreatingVersion: false
      }
      break
    case ACTIONS.VERSION_MANAGEMENT_CREATE_NEW_VERSION + '_FULFILLED':
      state = {
        ...state,
        isCreatingVersion: false
      }
      break
  }
  return state
}
